<template>
  <div
    class="container-fluid page-header-box"
    :style="{
      'background-image':
        'url(' + require('/src/assets/img/shutterstock_.png') + ')',
    }"
  >
    <div class="container page-title-box">
      <h1>{{ pageName }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageName"],
};
</script>
<style scoped>
.page-header-box {
  height: 200px;
  background-color: var(--m3--sys--light--primary);
  mix-blend-mode: multiply;
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
  position: relative;
  background-blend-mode: multiply;
  background-size: cover;
  background-position: center;
}

.page-title-box {
  /* M3/display/small */
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  /* identical to box height, or 122% */
  text-align: center;
  /* M3/read-only/dark/white */
  color: var(--m3--read-only--dark--white);
}
</style>